import React from 'react';

import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';

import { FeeDeliveryItem, Total } from './styled';

interface DeliveryFeesProps {
  deliveryFee: number | null;
  deliveryFeeDiscount: number | null;
  isFreeDelivery?: boolean;
  isLoading?: boolean;
}

const DeliveryFees: React.FC<React.PropsWithChildren<DeliveryFeesProps>> = ({
  deliveryFee,
  isFreeDelivery,
  deliveryFeeDiscount,
  isLoading,
}) => {
  const { formatMessage } = useIntl();
  if (isLoading) {
    return <CurrencyLineSkeleton />;
  }
  return isFreeDelivery ? (
    <FeeDeliveryItem aria-labelledby="delivery-fee-amount-label">
      {formatMessage({
        id: 'free',
      })}
      &nbsp;
      <Currency amount={deliveryFeeDiscount!} />
    </FeeDeliveryItem>
  ) : (
    <Total aria-labelledby="delivery-fee-amount-label">
      <Currency amount={deliveryFee!} />
    </Total>
  );
};

export default DeliveryFees;
